export default [
  {
    char: '😀',
    name: 'grinning',
  },
  {
    char: '😬',
    name: 'grimacing',
  },
  {
    char: '😂',
    name: 'joy',
  },
  {
    char: '😃',
    name: 'smiley',
  },
  {
    char: '😄',
    name: 'smile',
  },
  {
    char: '😅',
    name: 'sweat_smile',
  },
  {
    char: '😆',
    name: 'laughing',
  },
  {
    char: '😇',
    name: 'innocent',
  },
  {
    char: '😉',
    name: 'wink',
  },
  {
    char: '😊',
    name: 'blush',
  },
  {
    char: '😋',
    name: 'yum',
  },
  {
    char: '😌',
    name: 'relieved',
  },
  {
    char: '😍',
    name: 'heart_eyes',
  },
  {
    char: '😘',
    name: 'kissing_heart',
  },
  {
    char: '😙',
    name: 'kissing_smiling_eyes',
  },
  {
    char: '😝',
    name: 'stuck_out_tongue_closed_eyes',
  },
  {
    char: '😎',
    name: 'sunglasses',
  },
  {
    char: '😏',
    name: 'smirk',
  },
  {
    char: '😶',
    name: 'no_mouth',
  },
  {
    char: '😐',
    name: 'neutral_face',
  },
  {
    char: '😒',
    name: 'unamused',
  },
  {
    char: '😳',
    name: 'flushed',
  },
  {
    char: '😞',
    name: 'disappointed',
  },
  {
    char: '😟',
    name: 'worried',
  },
  {
    char: '😠',
    name: 'angry',
  },
  {
    char: '😔',
    name: 'pensive',
  },
  {
    char: '😕',
    name: 'confused',
  },
  {
    char: '😣',
    name: 'persevere',
  },
  {
    char: '😤',
    name: 'triumph',
  },
  {
    char: '😮',
    name: 'open_mouth',
  },
  {
    char: '😱',
    name: 'scream',
  },
  {
    char: '😨',
    name: 'fearful',
  },
  {
    char: '😰',
    name: 'cold_sweat',
  },
  {
    char: '😯',
    name: 'hushed',
  },
  {
    char: '😧',
    name: 'anguished',
  },
  {
    char: '😢',
    name: 'cry',
  },
  {
    char: '😪',
    name: 'sleepy',
  },
  {
    char: '😓',
    name: 'sweat',
  },
  {
    char: '😭',
    name: 'sob',
  },
  {
    char: '😵',
    name: 'dizzy_face',
  },
];

export class Emoji {
  public char: any;
  public name: string;

  constructor(e: Emoji) {
    this.char = e.char;
    this.name = e.name;
  }
}
  
